export function readEnvVariable(envVariableName: string): string {
  return process.env[envVariableName] || '';
}
